import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventService } from 'src/app/services/event.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-for-shoppers',
  templateUrl: './for-shoppers.component.html',
  styleUrls: ['./for-shoppers.component.scss']
})
export class ForShoppersComponent implements OnInit, OnDestroy {
  public redirect = environment.applyRedirect;

  constructor(
    private eventService: EventService
  ) {}

  public scrollTo(elementId: string): void {
    (document.querySelector(`#${elementId}`) as Element).scrollIntoView({ behavior: "smooth" });
  }
  ngOnInit(): void {
    this.scrollTo('top');
    //this.eventService.howItWorksHide();
    this.eventService.mobileDisplayLogoToolbar.next(true);
  }
  ngOnDestroy(): void {
    this.eventService.howItWorksShow();
  }

}
